import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {TITLE_SCREEN_SUB_TYPES} from '../../../models/componentModels';
import Button from '../../buttons/IconButton';//eslint-disable-line import/no-named-as-default
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as componentHelper from '../../../helpers/componentHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as localStorage from '../../../localStorage/localStorage';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class TitleScreenManager extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            screen: this.props.screen,
           sub_screen: {}
        };
        this.getSubScreen = this.getSubScreen.bind(this);
    }

    componentDidMount() {
        this.getSubScreen();
    }

    componentWillReceiveProps(nextProps) {

    }

    getSubScreen(){
        let sub_screen = componentHelper.getDefaultSubTitleScreenComponent();
        if(appHelper.isDefined(this.state.screen.screen_sub_type_code)){
            sub_screen =  componentHelper.getSubTitleScreenComponentByType(this.state.screen.screen_sub_type_code);
        }

        this.setState({sub_screen : Object.assign({},sub_screen)});
    }

    render() {
        let Component = appHelper.isDefined(this.state.sub_screen.component) ? this.state.sub_screen.component : undefined;
        return (
            appHelper.isDefined(Component)
            ?
                <Component screen={this.state.screen} biteCallbacks={this.props.biteCallbacks} />
            :null
        );
    }
}

TitleScreenManager.propTypes = {
    screen: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    titles: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
};

TitleScreenManager.contextTypes = {
    router: PropTypes.object

};

function mapStateToProps(state, ownProps) {
    return {
        titles: state.titles,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TitleScreenManager);



/** WEBPACK FOOTER **
 ** ./src/components/screens/titleScreen/TitleScreenManager.js
 **/